<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import LiveStreamView from 'src/components/Camera/CameraPlayer/LiveStreamView.svelte';
	import CameraStatusLabel from 'src/components/Camera/SidepanelLayout/CameraStatusLabel.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import LastRecordingsV2 from '../../DeviceDrawer/LastRecordingsV2.svelte';
	import RecordingKeyPrompt from 'src/components/Camera/CameraPlayer/RecordingKeyPrompt.svelte';
	import RecordingSetupPrompt from 'src/components/Camera/CameraPlayer/RecordingSetupPrompt.svelte';
	import { ensureDeviceEncryption } from 'src/components/Camera/helpers/recording-key-management';
	import { real_id } from 'src/helpers/interface_helpers';

	export let device: Device;

	let lastEnsuredId = '';

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	// Resolve the device key up-front, else start setup/unlock; gated so it runs once per device id.
	$: if (device?.id && real_id(device.id) !== lastEnsuredId) {
		lastEnsuredId = real_id(device.id);
		ensureDeviceEncryption(device);
	}
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center align-items-center"
	>
		<CameraStatusLabel {device} {status} {settings} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div slot="content">
		<LiveStreamView {device} {status} {settings} />
		<LastRecordingsV2 {device} deviceId={device.id} />
		<CameraCloudStoragePromoBanner deviceId={device?.id} />
		<RecordingKeyPrompt {device} />
		<RecordingSetupPrompt {device} />
	</div>
</DeviceViewStateWrapper>
